<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>

    <div class="row myrow">

        <div class="col-md-6">
            <div class="label">
                <strong> {{mailingAddress1}}</strong>
            </div>
            <div class="lblValue">{{dataObject.Address1}}</div>
        </div>
        <div class="col-md-6">
            <div class="label">
                <strong> {{mailingAddress2}}</strong>
            </div>
            <div class="lblValue">{{dataObject.Address2}}</div>

        </div>

    </div>
    <div class="row myrow">

        <div class="col-md-6">
            <div class="label">
                <strong> {{city}}</strong>
            </div>
            <div class="lblValue">{{dataObject.City}}</div>
        </div>
        <div class="col-md-6">
            <div class="label">
                <strong> {{state}}</strong>
            </div>
            <div class="lblValue">{{dataObject.State}}</div>

        </div>

    </div>
    <div class="row myrow">

        <div class="col-md-6">
            <div class="label">
                <strong> {{zipcode}}</strong>
            </div>
            <div class="lblValue">{{dataObject.Zipcode}}</div>
        </div>
        <div class="col-md-6">
            <div class="label">
                <strong> {{contact}}</strong>
            </div>
            <div class="lblValue">{{dataObject.ContactNumber }}</div>

        </div>
    </div>
    <div class="row myrow">

        <div class="col-md-6">
            <div class="label">
                <strong> {{fax}}</strong>
            </div>
            <div class="lblValue">{{dataObject.Fax }}</div>
        </div>
        <div class="col-md-6">
            <div class="lblValue">&nbsp;</div>

        </div>

    </div>



</div>
<div mat-dialog-actions style="text-align: center;">
    <a type="submit" (click)="onNoClick()" class="btn btn-main">{{submit}}</a>
    <a style="cursor: pointer;"(click)="closeDialog()"  >Skip</a>

</div>